import { FacebookLoginOptions } from './strategy';
import analytic from '@/scripts/libs/analytic';
import { makeAuthTrackerPayload } from './helpers';

export const facebookLoginStrategy = (options: FacebookLoginOptions): void => {
  analytic.send({
    category: 'sign-in',
    action: 'facebook',
  });
  window.fbq?.('track', 'CompleteRegistration');

  const loginUrl = new URL('/fb_login', location.origin);

  if (options?.callback) {
    loginUrl.searchParams.append('callback', options.callback);
  }
  if (options?.origin) {
    loginUrl.searchParams.append('origin', options.origin);
  }

  const authTrackerParams = makeAuthTrackerPayload(options.authTracker);
  Object.entries(authTrackerParams)
    .forEach(([key, value]) => {
      loginUrl.searchParams.append(key, value);
    })
  ;

  window.location.href = loginUrl.href;
};
